const React = require('react');

const Chevron = ({ className }) => (
  <svg className={className} width="12" height="8" viewBox="0 0 10 6" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.99814 3.9517L1.40175 0.355309L0.553223 1.20384L4.99814 5.64875L9.4468 1.20009L8.59827 0.351562L4.99814 3.9517Z" fill="#009EE3" fillOpacity="0.8" />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.99814 3.9517L1.40175 0.355309L0.553223 1.20384L4.99814 5.64875L9.4468 1.20009L8.59827 0.351562L4.99814 3.9517Z" fill="#009EE3" fillOpacity="0.8" />
  </svg>

);

module.exports = Chevron;
